import React from "react";
import { ResetPasswordUsingToken } from "supertokens-auth-react/recipe/emailpassword/prebuiltui";

class ResetPasswordPage extends React.Component {
  render() {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <ResetPasswordUsingToken />
      </div>
    );
  }
}

export default ResetPasswordPage;
